module.exports = __webpack_public_path__ + "img/48.242e99f8.jpg";